import { render, staticRenderFns } from "./bosManage.vue?vue&type=template&id=3f86741d"
import script from "./bosManage.vue?vue&type=script&lang=js"
export * from "./bosManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f86741d')) {
      api.createRecord('3f86741d', component.options)
    } else {
      api.reload('3f86741d', component.options)
    }
    module.hot.accept("./bosManage.vue?vue&type=template&id=3f86741d", function () {
      api.rerender('3f86741d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pec/bosManage.vue"
export default component.exports